export const endpointName = 'Paragraph';
export const createParagraphEndpoint = 'Paragraph';
export const getParagraphByIdEndpoint = 'Paragraph';
export const getParagraphsForChapterByIdEndpoint = 'Paragraph/byGroupId';
export const updateParagraphEndpoint = 'Paragraph/Update';
export const deleteParagraphEndpoint = 'Paragraph/Delete';
